module.exports = __webpack_public_path__ + "static/media/Kyrgyzstan.00d96e1b.png";